import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookMarked, Clock, Loader2, ChevronRight, User } from "lucide-react";

export default function MyDiary() {
  const { selectedSchoolId } = useAuth();
  const [entries, setEntries] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/my-diary").then((r) => setEntries(r.data)).catch(() => setEntries([])); }, [selectedSchoolId]);

  if (entries === null) return <div className="grid h-64 place-items-center"><Loader2 className="h-7 w-7 animate-spin text-blue-700" /></div>;

  const open = (e) => navigate(`/diario?class_id=${e.class_id}&subject_id=${e.subject_id}&cn=${encodeURIComponent(e.class_name)}&sn=${encodeURIComponent(e.subject)}`);

  return (
    <div>
      <PageHeader title="Meu Diário" subtitle="Suas turmas e disciplinas — chamada, aulas e notas em poucos cliques" />
      {entries.length === 0 ? (
        <EmptyState icon={BookMarked} title="Nenhuma turma atribuída" description="Você ainda não possui turmas/disciplinas vinculadas. Fale com a Coordenação." />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {entries.map((e, i) => (
            <button key={i} data-testid={`my-diary-entry-${i}`} onClick={() => open(e)}
              className="card-hover flex flex-col rounded-2xl border border-slate-200 bg-white p-5 text-left">
              <div className="flex items-center justify-between">
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-blue-700 font-display text-lg font-black text-white">{e.class_name}</div>
                <ChevronRight className="h-5 w-5 text-slate-300" />
              </div>
              <h3 className="mt-3 font-display text-lg font-bold text-slate-900">{e.subject}</h3>
              <p className="text-sm text-slate-500">{e.grade} · Turma {e.class_name}</p>
              <div className="mt-3 flex flex-wrap gap-2 text-xs text-slate-500">
                <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-0.5 font-semibold"><Clock className="h-3 w-3" /> {e.shift || "—"}</span>
                {e.teacher && <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-0.5 font-semibold"><User className="h-3 w-3" /> {e.teacher}</span>}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
